/**
 * Kaufnebenkosten (land transfer tax, notary, land registry) as a share of the
 * purchase price. The real rate varies by Bundesland, so every label built
 * from this carries a "ca.". Labels interpolate it, so the figure the customer
 * reads and the figure the total is computed from cannot drift.
 */
export const ANCILLARY_COST_RATE = 0.1

/**
 * German standard rate.
 *
 * Two families of price meet here and neither is ever grossed up from the
 * other: what a customer is quoted is stored gross, and a product's unit
 * price is stored net. This only ever divides out — off a customer total to
 * show the tax in it, or off a shop's page price on the way into the
 * catalogue.
 */
export const VAT_RATE = 0.19

/** The rate as the surfaces state it. Every one interpolates the percentage
 *  into a "MwSt." line, and none of them wants the ratio. */
export const VAT_PERCENT = VAT_RATE * 100

/** Takes VAT out of a gross figure, at the standard rate unless a source
 *  states its own — a shop page that charges 7 % says so. */
export function netFromGross(gross: number, rate = VAT_RATE): number {
  return gross / (1 + rate)
}
